import axios from "axios";
import { getFromStorage, saveToStorage } from "../../../used-vue/api/Storage";
import { debounce } from "lodash";
import { format } from 'date-fns';
import { getDefaultTerm, getDefaultDeposit, getDefaultMileage, getDepositContribution, getFinalPayment, getFirstFee, getPayments, getRoadsideAssistance, getEmptyQuoteWithPredictableKeys, getGovernmentGrant, getDepositContributionExcludingDealer, getDealerDepositContribution } from "../../api/finance/finance-helpers";

const state = {
    loading: true,
    financeLoading: true,
    availableParameters: {
        pcp: {
            available: false,
            minDeposit: null,
            maxDeposit: null,
            terms: [],
            mileages: [],
        },
        hp: {
            available: false,
            minDeposit: null,
            maxDeposit: null,
            terms: [],
        },
    },
    financeAvailable: false,

    financeModified: false,
    selectedFinance: null,
    selectedTerm: window.defaultTerm || getDefaultTerm(),
    selectedDeposit: window.defaultDeposit || getDefaultDeposit(),
    selectedMileage: getDefaultMileage(),

    quote: null,
    quoteWithPredictableKeys: getEmptyQuoteWithPredictableKeys(),
    quoteValidDate: null,
    cashPriceForced: false,
};
if (window.newVehicleQuoteValidDate) {
    state.quoteValidDate = newVehicleQuoteValidDate;
} else {
    state.quoteValidDate = format(new Date(), 'Do MMM YYYY');
}

let savedTerm = getFromStorage('new_term', null);
if (savedTerm !== null) {
    state.selectedTerm = savedTerm;
}
let savedMileage = getFromStorage('new_mileage', null);
if (savedMileage !== null) {
    state.selectedMileage = savedMileage;
}
let savedDeposit = getFromStorage('new_deposit', null);
if (savedDeposit !== null) {
    state.selectedDeposit = savedDeposit;
}

if (getFromStorage('new_finance_modified') == 'Y') {
    state.financeModified = true;
}

const getters = {
};

const actions = {
    initAvailableParameters({ dispatch, commit, rootState }) {
        return new Promise((resolve, reject) => {
            const vehicle = rootState.NewVehicleData.vehicle;
            if (!vehicle) {
                reject('No vehicle selected');
                return;
            }

            commit('setLoading', true);

            dispatch('getAvailableParameters', vehicle)
                .then(response => {
                    let pcpFound = false;
                    let hpFound = false;
                    response.Products.forEach(cwProduct => {
                        if (cwProduct.Key.toLowerCase() == 'pcp') {
                            if (typeof cwProduct.Error != 'undefined' && cwProduct.Error !== null) {
                                return;
                            }

                            if (typeof cwProduct.Deposit !== 'undefined' && typeof cwProduct.Deposit.Minimum !== 'undefined' && typeof cwProduct.Deposit.Maximum !== 'undefined') {
                                commit('setAvailableParameters', {
                                    pcp: {
                                        minDeposit: parseFloat(cwProduct.Deposit.Minimum),
                                        maxDeposit: parseFloat(cwProduct.Deposit.Maximum)
                                    }
                                });
                            } else {
                                commit('setAvailableParameters', {
                                    pcp: {
                                        minDeposit: 0.0,
                                        maxDeposit: Math.ceil(parseFloat((vehicle.pricing_display_price * 0.4 * 100) / 100)),
                                    }
                                });
                                return;
                            }

                            if (typeof cwProduct.Term !== 'undefined' && typeof cwProduct.Term.Values !== 'undefined') {
                                const terms = cwProduct.Term.Values;
                                terms.sort((a, b) => {
                                    a = parseInt(a);
                                    b = parseInt(b);
                                    if (a < b) {
                                        return -1;
                                    }
                                    if (a > b) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                commit('setAvailableParameters', {
                                    pcp: {
                                        terms: terms
                                    }
                                });
                            } else {
                                commit('setAvailableParameters', {
                                    pcp: {
                                        terms: [
                                            36,
                                            48
                                        ]
                                    }
                                });
                            }

                            if (typeof cwProduct.AnnualMileage !== 'undefined' && typeof cwProduct.AnnualMileage.Values !== 'undefined') {
                                const mileages = cwProduct.AnnualMileage.Values;
                                mileages.sort((a, b) => {
                                    a = parseInt(a);
                                    b = parseInt(b);
                                    if (a < b) {
                                        return -1;
                                    }
                                    if (a > b) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                commit('setAvailableParameters', {
                                    pcp: {
                                        mileages: mileages
                                    }
                                });
                            } else {
                                commit('setAvailableParameters', {
                                    pcp: {
                                        mileages: [
                                            5000,
                                            6000,
                                            7000,
                                            8000,
                                            9000,
                                            10000,
                                            12000,
                                            15000,
                                            20000
                                        ]
                                    }
                                });
                            }

                            pcpFound = true;
                            return;
                        }


                        if (cwProduct.Key.toLowerCase() == 'hp') {
                            if (typeof cwProduct.Error != 'undefined' && cwProduct.Error !== null) {
                                return;
                            }

                            if (typeof cwProduct.Deposit !== 'undefined' && typeof cwProduct.Deposit.Minimum !== 'undefined' && typeof cwProduct.Deposit.Maximum !== 'undefined') {
                                commit('setAvailableParameters', {
                                    hp: {
                                        minDeposit: parseFloat(cwProduct.Deposit.Minimum),
                                        maxDeposit: parseFloat(cwProduct.Deposit.Maximum)
                                    }
                                });
                            } else {
                                commit('setAvailableParameters', {
                                    hp: {
                                        minDeposit: 0.0,
                                        maxDeposit: Math.ceil(parseFloat((vehicle.pricing_display_price * 0.7 * 100) / 100)),
                                    }
                                });
                                return;
                            }

                            if (typeof cwProduct.Term !== 'undefined' && typeof cwProduct.Term.Values !== 'undefined') {
                                const terms = cwProduct.Term.Values;
                                terms.sort((a, b) => {
                                    a = parseInt(a);
                                    b = parseInt(b);
                                    if (a < b) {
                                        return -1;
                                    }
                                    if (a > b) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                commit('setAvailableParameters', {
                                    hp: {
                                        terms: terms
                                    }
                                });
                            } else {
                                commit('setAvailableParameters', {
                                    hp: {
                                        terms: [
                                            12,
                                            18,
                                            24,
                                            30,
                                            36,
                                            42,
                                            48,
                                            54,
                                            60,
                                        ]
                                    }
                                });
                            }
                            hpFound = true;
                            return;
                        }
                    });
                    commit('setAvailableParameters', { pcp: {available: pcpFound }});
                    commit('setAvailableParameters', { hp: {available: hpFound }});
                    commit('setFinanceAvailable', (vehicle.have_pch == 1 || pcpFound || hpFound));
                    commit('setLoading', false);
                    resolve(response);
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                });
        });
    },
    getAvailableParameters({ }, vehicle) {
        return new Promise((resolve, reject) => {
            // Try to collect available params from session storage cache
            const cachedFinanceParams = sessionStorage.getItem('new.finance.params.' + vehicle.id);

            if (cachedFinanceParams !== null) {
                try {
                    // If we're able to parse what's stored, resolve the promise with it
                    resolve(JSON.parse(cachedFinanceParams));
                    return;
                } catch (error) {
                    console.error(error);
                }
            }

            const buildToOrderVehicleData = {
                "OnTheRoadPrice": vehicle.pricing_display_price,
                "IsNew": true,
                "Identifier": (vehicle.titre_code) ? vehicle.titre_code : vehicle.cap_id,
                "IdentifierType": 'Titre',
                "Type": (vehicle.type == 'car') ? 'Car' : 'Lcv',
            };

            if (!vehicle.titre_code) {
                if (buildToOrderVehicleData.Type == 'Car') {
                    buildToOrderVehicleData.IdentifierType = 'CapCarShortCode';
                } else {
                    buildToOrderVehicleData.IdentifierType = 'CapLcvShortCode';
                }
            }

            // If we got this far, then we were unable to get finance params from cache
            // Build the JSON request data for this vehicle
            axios.post('https://services.codeweavers.net/api/finance/defaults', {
                Credentials: {
                    ApiKey: "ONH75GHd8x0gu6yfJ6",
                },
                BuildToOrderVehicle: buildToOrderVehicleData,
            })
                .then(response => {
                    if (typeof response.data.Error != 'undefined' && response.data.Error == true) {
                        sessionStorage.setItem('new.finance.params.' + vehicle.id, JSON.stringify({}));
                        reject();
                        return;
                    }
                    sessionStorage.setItem('new.finance.params.' + vehicle.id, JSON.stringify(response.data));

                    resolve(response.data);
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                })
        });
    },
    calculateFinance:
        debounce(({ dispatch, commit, rootState, state }, options) => {
            return new Promise((resolve, reject) => {
                const vehicle = rootState.NewVehicleData.vehicle;
                if (!vehicle) {
                    reject('No vehicle selected');
                    return;
                }

                let cashPrice = vehicle.pricing_display_price;
                let forceCashPrice = (typeof options != 'undefined' && typeof options.forceCashPrice != 'undefined' && options.forceCashPrice) ? options.forceCashPrice : false;

                if (!forceCashPrice && state.selectedFinance == 'pcp' && vehicle.price_PCP > 0) {
                    console.log('Using PCP price for finance calculation');
                    cashPrice = vehicle.price_PCP;
                } else if (!forceCashPrice && state.selectedFinance == 'hp' && vehicle.price_HP > 0) {
                    cashPrice = vehicle.price_HP;
                }

                if (vehicle.titre_code == '1PPDSYTEUFT0A0B0') {
                    if (state.selectedTerm == 37 && state.selectedDeposit >= 15100) {
                        cashPrice = 49650;
                    }
                }

                let identifier = (vehicle.titre_code) ? vehicle.titre_code : vehicle.cap_id;
                let identifierType = 'Titre';

                if (!vehicle.titre_code) {
                    if (vehicle.type == 'car') {
                        identifierType = 'CapCarShortCode';
                    } else {
                        identifierType = 'CapLcvShortCode';
                    }
                }

                const request = {
                    "Credentials":{
                        "ApiKey": "ONH75GHd8x0gu6yfJ6"
                        },
                    "Customer":{
                        "Reference": ''
                    },
                    "Parameters":{
                        "Term": state.selectedTerm,
                        "Deposit": state.selectedDeposit,
                        "DepositType": "Amount",
                        "AnnualMileage": state.selectedMileage,
                        "IsTelematics": false,
                    },
                    "VehicleRequests":[
                        {
                            "Id": vehicle.id,
                            "Vehicle":{
                                "CashPrice": cashPrice,
                                "RegistrationDate": format(new Date, 'dd/MM/yyyy'),
                                "IsNew": true,
                                "Identifier": identifier,
                                "IdentifierType": identifierType,
                                "Type": (vehicle.type == 'car') ? 'Car' : 'Lcv',
                                "DealerVehicleUrl": window.location.href,
                            },
                        }
                    ]
                };

                if (state.selectedFinance == 'pcp') {
                    request.VehicleRequests[0].Products = [{"Key": "PCP"}];
                } else if (state.selectedFinance == 'hp') {
                    request.VehicleRequests[0].Products = [{"Key": "HP"}];
                }
                commit('setFinanceLoading', true);
                commit('updateQuoteWithPredictableKeys', getEmptyQuoteWithPredictableKeys());
                axios.post('https://services.codeweavers.net/public/v3/JsonFinance/Calculate', request)
                    .then(response => {
                        commit('setCashPriceForced', forceCashPrice);
                        if (typeof response.data['VehicleResults'] == 'undefined') {
                            commit('setQuote', null);
                            reject(error);
                            commit('setFinanceLoading', false);
                            return;
                        }
                        if (typeof response.data['VehicleResults'][0] == 'undefined') {
                            commit('setQuote', null);
                            reject(error);
                            commit('setFinanceLoading', false);
                            return;
                        }
                        if (typeof response.data['VehicleResults'][0]['FinanceProductResults'] == 'undefined') {
                            commit('setQuote', null);
                            reject(error);
                            commit('setFinanceLoading', false);
                            return;
                        }
                        if (typeof response.data['VehicleResults'][0]['FinanceProductResults'].length == 0) {
                            commit('setQuote', null);
                            reject(error);
                            commit('setFinanceLoading', false);
                            return;
                        }
                        response.data['VehicleResults'][0]['FinanceProductResults'].forEach(productResult => {
                            if (state.selectedFinance == 'pcp' && productResult.Key == 'PCP') {
                                dispatch('setupActiveQuote', productResult);
                                return;
                            }
                            if (state.selectedFinance == 'hp' && productResult.Key == 'HP') {
                                dispatch('setupActiveQuote', productResult);
                                return;
                            }
                        });
                        if (!forceCashPrice && vehicle.brand == 'peugeot' && state.quoteWithPredictableKeys.apr == 0) {
                            console.log('Peugeot finance APR is 0, forcing cash price calculation');
                            return dispatch('calculateFinance', {
                                forceCashPrice: true
                            }).then(response => {
                                resolve(response.data);
                            }).catch(error => {
                                reject(error);
                            });
                        }
                        commit('setFinanceLoading', false);
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error(error);
                        commit('setQuote', null);
                        reject(error);
                        commit('setFinanceLoading', false);
                    })
            });
        },
        350,
        {
            leading: false,
            trailing: true
        }
    ),
    setupActiveQuote({commit, state, rootState}, quote) {
        commit('setQuote', quote);
        if (typeof quote.HasError != 'undefined' && quote.HasError) {
            commit('updateQuoteWithPredictableKeys', getEmptyQuoteWithPredictableKeys());
            return;
        }
        if (typeof quote.Quote == 'undefined') {
            commit('updateQuoteWithPredictableKeys', getEmptyQuoteWithPredictableKeys());
            return;
        }
        if (typeof quote.Quote.AllInclusiveRegularPayment == 'undefined') {
            commit('updateQuoteWithPredictableKeys', getEmptyQuoteWithPredictableKeys());
            return;
        }
        const payments = getPayments(quote);
        if (!payments) {
            commit('updateQuoteWithPredictableKeys', getEmptyQuoteWithPredictableKeys());
            return;
        }
        let numPayments = 0;
        payments.forEach(payment => {
            if (payment.amount == quote.Quote.AllInclusiveRegularPayment) {
                numPayments += payment.quantity;
            }
        });

        const vehicle = rootState.NewVehicleData.vehicle;
        if (!vehicle) {
            commit('updateQuoteWithPredictableKeys', {
                numPayments: numPayments,
                monthly: quote.Quote.AllInclusiveRegularPayment,
                firstFee: getFirstFee(quote),
                depCon: getDepositContribution(quote),
                depConExcludingDealer: getDepositContributionExcludingDealer(quote),
                dealerDepCon: getDealerDepositContribution(quote),
                finalPayment: getFinalPayment(quote),
                roadsideAssistance: getRoadsideAssistance(quote),
                governmentGrant: getGovernmentGrant(quote),
                apr: quote.Quote.Apr,
                financePrice: null,
            });
            return;
        }

        const retailPrice = parseFloat(vehicle.pricing_display_price);
        const cashPrice = parseFloat((quote.Quote?.CashPrice || retailPrice));

        commit('updateQuoteWithPredictableKeys', {
            numPayments: numPayments,
            monthly: quote.Quote.AllInclusiveRegularPayment,
            firstFee: getFirstFee(quote),
            depCon: getDepositContribution(quote),
            depConExcludingDealer: getDepositContributionExcludingDealer(quote),
            dealerDepCon: getDealerDepositContribution(quote),
            finalPayment: getFinalPayment(quote),
            roadsideAssistance: getRoadsideAssistance(quote),
            governmentGrant: getGovernmentGrant(quote),
            apr: quote.Quote.Apr,
            financePrice: cashPrice,
        });
    }
};

const mutations = {
    setAvailableParameters(state, params) {
        Object.keys(state.availableParameters).forEach(financeKey => {
            if (typeof params[financeKey] == 'undefined') {
                return;
            }
            Object.keys(state.availableParameters[financeKey]).forEach(key => {
                if (typeof params[financeKey][key] == 'undefined') {
                    return;
                }
                state.availableParameters[financeKey][key] = params[financeKey][key];
            })
        });
    },
    setFinanceAvailable(state, financeAvailable) {
        state.financeAvailable = financeAvailable;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setFinanceLoading(state, financeLoading) {
        state.financeLoading = financeLoading;
    },
    setSelectedFinance(state, selectedFinance) {
        state.selectedFinance = selectedFinance;
    },
    setSelectedTerm(state, term) {
        state.selectedTerm = term;
        saveToStorage('new_term', term);
        saveToStorage('new_finance_modified', 'Y');
    },
    setSelectedDeposit(state, deposit) {
        state.selectedDeposit = deposit;
        saveToStorage('new_deposit', deposit);
        saveToStorage('new_finance_modified', 'Y');
    },
    setSelectedMileage(state, mileage) {
        state.selectedMileage = mileage;
        saveToStorage('new_mileage', mileage);
        saveToStorage('new_finance_modified', 'Y');
    },
    setQuote(state, quote) {
        state.quote = quote;
    },
    updateQuoteWithPredictableKeys(state, quoteWithPredictableKeys) {
        Object.keys(quoteWithPredictableKeys).forEach(key => {
            if (typeof state.quoteWithPredictableKeys[key] == 'undefined') {
                console.error('Unexpected key for quoteWithPredictableKeys', key);
                return;
            }
            state.quoteWithPredictableKeys[key] = quoteWithPredictableKeys[key];
        })
    },
    setFinanceModified(state, financeModified) {
        state.financeModified = financeModified;
    },
    setCashPriceForced(state, cashPriceForced) {
        state.cashPriceForced = cashPriceForced;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

